if (!customElements.get('bd-room-picker')) {
  customElements.define('bd-room-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.rows = Array.from(this.querySelectorAll('[data-room-product]'));
      this.addButton = this.querySelector('[data-room-add]');
      this.status = this.querySelector('[data-room-status]');
      this.busy = false;
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-AU', {style: 'currency', currency: this.dataset.currency || 'AUD', currencyDisplay: 'narrowSymbol'});
      this.classList.add('is-ready');
      this.addEventListener('change', event => {
        if (event.target.matches('[data-room-variant]')) this.updateVariant(event.target.closest('[data-room-product]'));
        this.status.textContent = '';
        this.update();
      }, {signal: this.abort.signal});
      this.querySelector('[data-room-all]').addEventListener('click', () => {
        const enabled = this.rows.map(row => row.querySelector('[data-room-check]')).filter(input => !input.disabled);
        const allSelected = enabled.length > 0 && enabled.every(input => input.checked);
        enabled.forEach(input => { input.checked = !allSelected; });
        this.status.textContent = '';
        this.update();
      }, {signal: this.abort.signal});
      this.addButton.addEventListener('click', () => this.addToCart(), {signal: this.abort.signal});
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
    updateVariant(row) {
      const option = row.querySelector('[data-room-variant]').selectedOptions[0];
      const check = row.querySelector('[data-room-check]');
      check.disabled = option.dataset.available !== 'true';
      if (check.disabled) check.checked = false;
      row.querySelector('[data-room-stock]').hidden = !check.disabled;
      const notice = row.querySelector('[data-room-notice]');
      const note = option.textContent.match(/\(([^)]+)\)/);
      notice.textContent = !check.disabled && note ? note[1] : '';
      notice.hidden = !notice.textContent;
      row.querySelector('[data-room-price]').textContent = option.dataset.priceText;
      row.querySelectorAll('[data-room-link]').forEach(link => { link.href = option.dataset.url; });
      const img = row.querySelector('img');
      if (img && option.dataset.image) {
        img.removeAttribute('srcset');
        img.src = option.dataset.image;
      }
    }
    selectedRows() {
      return this.rows.filter(row => {
        const input = row.querySelector('[data-room-check]');
        return input.checked && !input.disabled;
      });
    }
    update() {
      const selected = this.selectedRows();
      const total = selected.reduce((sum, row) => sum + Number(row.querySelector('[data-room-variant]').selectedOptions[0].dataset.price), 0);
      this.querySelector('[data-room-count]').textContent = selected.length + ' ' + this.dataset.countLabel;
      this.querySelector('[data-room-total]').textContent = this.money.format(total / 100) + ' ' + (this.dataset.currency || 'AUD');
      this.addButton.disabled = this.busy || selected.length === 0;
      this.rows.forEach(row => { row.classList.toggle('is-selected', row.querySelector('[data-room-check]').checked); });
      const availableCount = this.rows.filter(row => !row.querySelector('[data-room-check]').disabled).length;
      const all = this.querySelector('[data-room-all]');
      all.setAttribute('aria-pressed', String(selected.length > 0 && selected.length === availableCount));
      all.disabled = this.busy || availableCount === 0;
    }
    async addToCart() {
      if (this.busy) return;
      const selected = this.selectedRows();
      if (!selected.length) { this.status.textContent = this.dataset.emptyLabel; return; }
      const grouped = new Map();
      selected.forEach(row => {
        const id = row.querySelector('[data-room-variant]').value;
        grouped.set(id, (grouped.get(id) || 0) + 1);
      });
      const items = Array.from(grouped, ([id, quantity]) => ({id, quantity}));
      this.busy = true;
      this.update();
      this.addButton.textContent = this.dataset.addingLabel;
      this.status.textContent = '';
      const controls = Array.from(this.querySelectorAll('[data-room-check], [data-room-variant]'));
      const previousDisabled = controls.map(input => input.disabled);
      controls.forEach(input => { input.disabled = true; });
      try {
        const response = await fetch(this.dataset.root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : '');
        window.location.assign(this.dataset.root + 'cart');
      } catch (error) {
        this.status.textContent = this.dataset.errorLabel + (error.message && error.message !== 'Failed to fetch' ? ' ' + error.message : '');
        this.busy = false;
        controls.forEach((input, index) => { input.disabled = previousDisabled[index]; });
        this.addButton.textContent = this.dataset.idleLabel;
        this.update();
      }
    }
  });
}
